/**
 * FeedbackPage — ScanFlow-Mobile.
 *
 * Identisch zu Planer-Mobile, nur App-Name "scanflow" → Endpoint
 * /api/scanflow/feedback. Keine Kategorie, kein Slack mehr — der
 * gewählte Bereich (page_path) liefert den Umsetzungs-Kontext.
 */

import { useNavigate } from "react-router-dom";
import { FeedbackForm, MTabs, MTopBar, apiPost } from "@vimaana/ui";
import type { FeedbackFormPayload, FeedbackPage } from "@vimaana/ui";

const TABS = [
  { id: "inbox", label: "Rechnungen", ic: "📥", to: "/inbox" },
  { id: "erfassen", label: "Scannen", ic: "📷", to: "/erfassen" },
  { id: "profil", label: "Profil", ic: "◌", to: "/profil" },
];

const PAGES: FeedbackPage[] = [
  { value: "allgemein", label: "Allgemein / app-weit" },
  { value: "/inbox", label: "Rechnungen (Inbox)" },
  { value: "/erfassen", label: "Scannen (Kamera)" },
  { value: "/profil", label: "Profil" },
];

export default function FeedbackPage() {
  const navigate = useNavigate();

  const handleSubmit = async (p: FeedbackFormPayload) => {
    try {
      const res = await apiPost<{ logged: boolean; feedback_id?: string; error?: string }>(
        "/api/scanflow/feedback",
        {
          beschreibung: p.beschreibung,
          page_path: p.page_path,
          screenshot_url: p.screenshot_url,
          context: p.context,
          app_version: "0.1.0",
        },
      );
      if (res.logged) return { ok: true };
      return { ok: false, error: res.error || "Feedback konnte nicht gespeichert werden." };
    } catch (e) {
      return { ok: false, error: e instanceof Error ? e.message : String(e) };
    }
  };

  return (
    <div className="m-app">
      <MTopBar label="Vimaana ScanFlow" title="Feedback" onMenu={() => navigate("/profil")} />
      <div style={{ padding: "20px" }}>
        <p style={{ fontSize: 14, color: "var(--m-ink-3)", lineHeight: 1.5, marginBottom: 20 }}>
          Bug, Idee oder Hinweis? Schick es uns hier — wir nehmen es in die Weiterentwicklung auf.
        </p>
        <FeedbackForm
          pages={PAGES}
          onSubmit={handleSubmit}
          onDone={() => navigate("/profil")}
        />
      </div>
      <MTabs items={TABS} />
    </div>
  );
}
